import { Pipe, PipeTransform } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map, startWith } from 'rxjs/operators';
import { LoadingState } from '../../interfaces/loading-state.interface';

@Pipe({ name: 'withLoading' })
export class WithLoadingPipe implements PipeTransform {
    public transform<T>(val: Observable<T>): Observable<LoadingState<T>> {
        return (
            val &&
            val.pipe(
                map((value) => ({ loading: false, value })),
                startWith({ loading: true }),
                catchError((error) => of({ loading: false, error }))
            )
        );
    }
}
